var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-center-start"},[_c('span',{class:[_vm.required ? 'text-danger':'text-white','mr-small']},[_vm._v("*")]),_c('div',{staticClass:"form-left-text",style:({width:_vm.width+'px'})},[_vm._v(_vm._s(_vm.leftText))]),_c('span',{staticClass:"text-dls",class:[_vm.leftText ? '':'text-white']},[_vm._v("：")])])
}
var staticRenderFns = []

export { render, staticRenderFns }